/*
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View } from 'react-native';

export default function App() {
  return (
    <View style={styles.container}>
      <Text>Open up App.tsx to start working on your app!</Text>
      <StatusBar style="auto" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
*/

import * as _cr from './src/_cr';
import * as _csLcl from './src/_csLcl';
import * as RclC from './src/_ccrRclC';
import * as DsnC from './src/_ccrDsnC';
import * as LdrC from './src/_ccrLdrC';
import * as MdlC from './src/_ccrMdlC';
import * as NgnC from './src/_ccrNgnC';
import * as _cmFTH from './src/_cmFTH';
import * as _gv from './src/_gv';
import * as _ht from './src/_ht';
import * as _hm from './src/_hm';

import * as icvHomeM10Rz from './src/icvHomeM10Rz';
import * as icvHomeM20Rz from './src/icvHomeM20Rz';
import * as icv_10M10Rz from './src/icv_10M10Rz';
import * as icv_41M10Rz from './src/icv_41M10Rz';
import * as icv_42M10Rz from './src/icv_42M10Rz';
import * as icv_60M10Rz from './src/icv_60M10Rz';
import * as icvI11M10Rz from './src/icvI11M10Rz';
import * as icvI12M10Rz from './src/icvI12M10Rz';
import * as icvI15M10Rz from './src/icvI15M10Rz';
import * as icvI18M10Rz from './src/icvI18M10Rz';
import * as icvI19M10Rz from './src/icvI19M10Rz';
import * as icvIz1M10Rz from './src/icvIz1M10Rz';
import * as icvLgnM10Rz from './src/icvLgnM10Rz';

/*
import React from 'react';
import * as _cmFTH from './src/_cmFTH';
import * as _gv from './src/_gv';
import * as _hm from './src/_hm';
import * as _hmDTM from './src/_hmDTM';
import * as _ht from './src/_ht';
import * as icvI1xM10Rz from './src/icvI1xM10Rz';
import * as icvI1yM10Rz from './src/icvI1yM10Rz';
import * as icvI1zM10Rz from './src/icvI1zM10Rz';
import * as icvLgnM10Rz from './src/icvLgnM10Rz';
import * as icvNewM10Rz from './src/icvNewM10Rz';

const $pagez = {
  icvNewM10Rz: {
    page: icvNewM10Rz.R,
    text: '新規ユーザー登録',
  },
  icvI1zM10Rz: {
    page: icvI1zM10Rz.R,
    text: '案件',
  },
  icvI1yM10Rz: {
    page: icvI1yM10Rz.R,
    text: 'ToDo',
  },
  icvI1xM10Rz: {
    page: icvI1xM10Rz.R,
    text: 'メンバー',
  },
};
*/
const $pagez = {
  s: { // ドメイン指定用
    page: icvLgnM10Rz.R,
    text: 'ログイン',
  },
  icvLgnM10Rz: {
    page: icvLgnM10Rz.R,
    text: 'ログイン',
  },
  icvHomeM10Rz: {
    page: icvHomeM10Rz.R,
    text: 'ホーム',
  },
  icvHomeM20Rz: {
    page: icvHomeM20Rz.R,
    text: 'その他設定',
  },
  icvI11M10Rz: {
    page: icvI11M10Rz.R,
    text: '販売店',
  },
  icvI12M10Rz: {
    page: icvI12M10Rz.R,
    text: '店種',
  },
  icvI15M10Rz: {
    page: icvI15M10Rz.R,
    text: '地区',
  },
  icvI18M10Rz: {
    page: icvI18M10Rz.R,
    text: `支払方法`,
  },
  icvI19M10Rz: {
    page: icvI19M10Rz.R,
    text: `事業者`,
  },
  icv_10M10Rz: {
    page: icv_10M10Rz.R,
    text: `ユーザー`,
  },
  icv_41M10Rz: {
    page: icv_41M10Rz.R,
    text: `役割`,
  },
  icv_42M10Rz: {
    page: icv_42M10Rz.R,
    text: `役割割当`,
  },
  icv_60M10Rz: {
    page: icv_60M10Rz.R,
    text: `祝日`,
  },
  icvIz1M10Rz: {
    page: icvIz1M10Rz.R,
    text: `配布`,
  },
};

export default function App() {

  const _sRz = _csLcl.usePz();
  const _udtThis = _csLcl.udtThis();

  return (
    _cr.c(RclC.R, {},
      _cr.c(DsnC.R, {
        frcUdt: _udtThis,
      }, 
        _cr.c(LdrC.R, {}, 
          _cr.c(MdlC.R, {}, 
            _cr.c(NgnC.R, {
              sRz: _sRz,
              cz: {
                pagez: $pagez,
                itlPageName: 'icvLgnM10Rz',
                ectOnce: async () => {

                  const _gUserz = _gv.useUserz();
                  await _gUserz.loadAsync();
                  if ( _gUserz.crt._10rz?._key > 0 ) {
                    const _ls = await _cmFTH.loadLsAsync2({
                      tgt: '_40r.load_40zRzAsync',
                      _10r_key: _gUserz.crt._10rz?._key,
                    });
                    const _dz = _hm.cvtLsToDz(_ls, ( _dz: _ht.dz ) => String(_dz._icn));
                    await _gUserz.saveAsync({
                      _40rz: _dz,
                    });
                    _sRz.udtAll();
                  }

                }
              }
            })
          )
        )
      )
    )
  );
}
